import { render } from "./MySuppliers.vue?vue&type=template&id=16c3ced3"
import script from "./MySuppliers.vue?vue&type=script&lang=js"
export * from "./MySuppliers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__